<template>
  <vs-prompt class="large" :title="!formData.id ? 'إضافة حدث' : 'تعديل حدث'"
             buttons-hidden @close="close" :active="active">

    <vs-input name="name" class="w-full" label-placeholder="عنوان الحدث" v-model="formData.title" />
    <div class="my-4">
      <label class="date-label"><small>التاريخ</small></label>
      <flat-pickr name="date" class="w-full" :config="configDateTimePicker" v-model="formData.date" />
    </div>
    <div class="w-full my-4">
      <label>المادة الدراسية</label>
      <vs-select v-model="formData.course_id" @change="formData.groups = []" class="w-full vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg">
        <vs-select-item v-for="course in courses" :key="course.id" :value="course.id" :text="`${course.name} (${course.id})`" />
      </vs-select>
    </div>
    <div class="w-full my-4">
      <label>اختر المجموعات</label>
      <ul class="centerx flex flex-wrap">
        <li v-for="(group, index) in courseGroups" :key="index">
          <vs-checkbox v-model="formData.groups" :vs-value="group.group"
                       v-validate="'required'" name="groups" data-vv-as="المجموعات" data-vv-validate-on="change">
            {{group.group}}
          </vs-checkbox>
        </li>
      </ul>
    </div>
    <vs-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="addEvent" :disabled="!validForm">حفظ</vs-button>
    </div>

  </vs-prompt>

</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { Arabic } from "flatpickr/dist/l10n/ar.js"

    export default {
        name: 'CalendarForm',
        components: { flatPickr },
        props: {
            active: {
                required: true,
                default: false,
                type: Boolean
            },
            date: {
                type: String,
                default: ''
            }
        },
        watch: {
            active(val) {
                if(val) this.formData.date = this.date
                else this.clearFields()
            }
        },
        data () {
            return {
                formData: { id: 0, title: '', date: '', groups: []},

                configDateTimePicker: {
                    disableMobile: "true",
                    enableTime: true,
                    minuteIncrement: 1,
                    dateFormat: 'Y-m-d H:i',
                    locale: Arabic,
                    time_24hr: true,
                },
            }
        },
        computed: {
            courses(){
                return this.$store.state.courses.all
            },
            courseGroups(){
                let courseId = this.formData.course_id ? this.formData.course_id : Object.values(this.courses)[0].id
                return this.$store.getters['courses/getAll'][courseId].groups
            },
            validForm() {
                return this.formData.title != '' && this.formData.date != '' && this.formData.groups.length > 0
            },
        },
        methods: {
            addEvent() {
                this.$startLoading('#simple-calendar-app')
                this.$store.dispatch('calendar/addEvent', this.formData)
                    .then(response =>{
                        this.$notifySuccess(response.successMessage)
                        this.close()
                    })
                    .finally(() => this.$closeLoading('#simple-calendar-app'))
            },
            clearFields() {
                this.formData = { id: 0, title: '', date: '', course_id: Object.values(this.courses)[0].id, groups: []}
            },
            close() {
                this.$emit('update:active', false)
            }
        }
    }
</script>
